import { render, staticRenderFns } from "./App.vue?vue&type=template&id=90ac7250&scoped=true&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&id=90ac7250&lang=stylus&scoped=true&"
import style1 from "./App.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90ac7250",
  null
  
)

export default component.exports